/** @format */

import Decimal from "decimal.js";
interface TreeNodeMap<any> {
  [k: number]: any;
}
/**
 * 数组转换为树形结构
 * @param data 对象数组
 * @param id 主键
 * @param pId 父id
 * @param children 子集key名称
 * @returns any[]
 */
export function buildTree(
  data: any[],
  id: string = "id",
  pId: string = "pId",
  children: string = "children"
): {
  arr: any[];
  map: TreeNodeMap<any>;
} {
  const map: TreeNodeMap<any> = {};
  const result: any[] = [];

  // 首先将所有节点放入 map 中
  data.forEach((item) => {
    // // @ts-ignore
    // if (item.money) {
    //   // @ts-ignore
    //   item.money = new Decimal(item.money);
    // }
    item.children = [];

    // @ts-ignore
    map[item[id]] = item;
  });

  // 然后根据 pId 关联子节点
  data.forEach((item) => {
    // @ts-ignore
    if (item[pId] !== null) {
      // @ts-ignore
      const parent = map[item[fIdKey]];
      if (parent) {
        // @ts-ignore
        parent[children].push(map[item.id]!);
      }
    } else {
      // @ts-ignore
      result.push(map[item[id]]!);
    }
  });

  return {
    arr: result,
    map,
  };
}

interface ArrReduce<T> {
  arr: T[];
  ver?: "lt" | "gt";
}
/**
 * 将数组里的某个属性值进行精确累加 该方法接受set方法时会将计算的属性转换成Decimal对象
 * @param arr
 * @returns
 */
export function arrReduce(opt: ArrReduce<any>): Decimal {
  const { arr } = opt;
  return arr.reduce<Decimal>((sum, item: any): Decimal => {
    if (item.sumMoney) {
      return sum.add(item.sumMoney());
    }
    return sum;
  }, new Decimal(0));
}

/**
 * 计算数组内所有支出总和
 * @param opt
 * @returns
 */
export function arrReduceTwo(opt: ArrReduce<any>): Decimal {
  const { arr } = opt;
  return arr.reduce<Decimal>((sum, item: any): Decimal => {
    if (item.money) {
      if (item.type == 1) return sum.add(item.money);
    }
    return sum;
  }, new Decimal(0));
}

/**
 * 计算数组内根据money对比0 返回总和
 * @param opt
 * @returns
 */
export function arrReduceSum(opt: ArrReduce<any>): Decimal {
  const { arr } = opt;
  return arr.reduce<Decimal>((sum, item: any): Decimal => {
    if (item.money) {
      if (item.money[opt.ver!](0)) return sum.add(item.money);
    }
    return sum;
  }, new Decimal(0));
}

/**
 *
 * 将对象数组里的某个属性值转换成Decimal对象
 * @param data
 * @param key
 * @returns
 */
export function updStringToDecimal<T>(data: Array<T>, key: string = "money"): Array<T> {
  for (let index = 0; index < data.length; index++) {
    const item = data[index];
    // @ts-ignore
    if (item[key]) {
      // @ts-ignore
      item[key] = new Decimal(item[key]);
    }
  }
  return data;
}

/**
 * 一维数组转二维数组
 * @param data
 * @returns
 */
export function convertToTwoDimensionalArray(data: any[], fIdKey: string = "pId") {
  // 先按sort字段排序
  const sortedData = [...data].sort((a, b) => {
    // 如果两个项都有sort字段，按sort字段排序
    if (typeof a.sort === "number" && typeof b.sort === "number") {
      return a.sort - b.sort;
    }
    // 如果只有a有sort字段，a排在前面
    if (typeof a.sort === "number" && typeof b.sort !== "number") {
      return -1;
    }
    // 如果只有b有sort字段，b排在前面
    if (typeof a.sort !== "number" && typeof b.sort === "number") {
      return 1;
    }
    // 如果两个都没有sort字段，保持原有顺序
    return 0;
  });

  // 分离第一层和第二层数据
  const firstLevel = sortedData.filter((item) => !item[fIdKey]);
  const secondLevel = sortedData.filter((item) => item[fIdKey] !== 0);

  // 构建二维数组
  const result: any = [];

  // 添加第一层数据
  firstLevel.forEach((item) => {
    // 初始化每项为包含自身和子项的数组
    const row = {
      ...item,
      children: [],
    };

    // 查找并添加子项
    row.children = secondLevel
      .filter((child) => child[fIdKey] === item.id)
      .sort((a, b) => {
        // 如果两个项都有sort字段，按sort字段排序
        if (typeof a.sort === "number" && typeof b.sort === "number") {
          return a.sort - b.sort;
        }
        // 如果只有a有sort字段，a排在前面
        if (typeof a.sort === "number" && typeof b.sort !== "number") {
          return -1;
        }
        // 如果只有b有sort字段，b排在前面
        if (typeof a.sort !== "number" && typeof b.sort === "number") {
          return 1;
        }
        // 如果两个都没有sort字段，保持原有顺序
        return 0;
      });
    if (row.children.length == 0) {
      delete row.children;
    }
    result.push(row);
  });

  return result;
}

/**
 * 数组对象按指定属性升序排序，无属性/属性无效的元素排在最后
 * @param {Array} arr - 待排序数组（元素为对象）
 * @param {string} prop - 排序属性名（如 'num'、'age'）
 * @returns {Array} 排序后的数组（原数组不变）
 */
export function sortByPropWithInvalidLast(arr:any, prop:any) {
  return [...arr].sort((a, b) => {
    // 解析属性值：有效返回数字，无效返回 Infinity
    const parseValidVal = (obj:any) => {
      const val = obj[prop];
      // 数字类型（非 NaN）
      if (typeof val === "number" && !isNaN(val)) return val;
      // 字符串类型（可转为数字）
      if (typeof val === "string" && !isNaN(Number(val))) return Number(val);
      // 其他情况（无属性、null、undefined、非数字）→ 无效
      return Infinity;
    };

    const valA = parseValidVal(a);
    const valB = parseValidVal(b);

    // 升序排序（无效元素因 Infinity 排在最后）
    return valA - valB;
  });
}

/**
 * 按groupId分类相邻，同组内按sort升序排序
 * @param data 原始sku数据数组
 * @returns 排序后的新数组（原数组不变）
 */
/**
 * 处理SKU数据：1.按groupId分类相邻+同组sort升序排序 2.统计每个groupId的数据条数
 * @param data 原始SKU数据数组
 * @returns 包含排序后数据和分组统计的结果对象
 */
export function processSkuData(data: any[]): any {
  // 1. 深拷贝原数组，避免修改原始数据（无嵌套可改为浅拷贝[...data]）
  const copyData = JSON.parse(JSON.stringify(data));

  // 2. 核心排序：先按groupId相邻，再按同组sort升序，null排最后
  copyData.sort((a: any, b: any) => {
    // 处理null，让null排最后
    if (a.groupId === null && b.groupId !== null) return 1;
    if (a.groupId !== null && b.groupId === null) return -1;
    if (a.groupId === null && b.groupId === null) return 0;
    // 同groupId按sort升序
    if (a.groupId === b.groupId) return a.sort - b.sort;
    // 不同groupId按数字升序（保证同组相邻）
    return (a.groupId as string).localeCompare(b.groupId as string, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  });

  // 3. 统计每个groupId的数量，null统一用字符串'null'作为key
  const groupCount: Record<string | "null", number> = {};
  copyData.forEach((item: any) => {
    // 定义分组key：null→'null'，其他直接取groupId字符串
    const key = item.groupId === null ? "null" : (item.groupId as string);
    // 计数：存在则+1，不存在则初始化为1
    groupCount[key] = (groupCount[key] || 0) + 1;
  });

  // 4. 返回结果：排序后数据 + 分组统计对象
  return {
    sortedData: copyData,
    groupCount,
  };
}
